import React from 'react';
import { PropsWithChildren } from 'react';
import { ContextMenuButtonProps } from './partials/ContextMenuButton';
import { CommonContextMenu } from './CommonContextMenu';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';

type ContainerWithCommonContextMenu = {
  toolTip: string;
  toolTipPlacement?: TooltipPlacement;
  actions?: ContextMenuButtonProps[];
};

export function ContainerWithCommonContextMenu(
  { toolTip, toolTipPlacement, actions, children }: PropsWithChildren<ContainerWithCommonContextMenu>) {
  return (
    <div className="context-menu__container">
      <div className="context-menu__content">{children}</div>
      {actions
        ? (
            <div className="context-menu__context-button-container">
              <CommonContextMenu toolTip={toolTip} toolTipPlacement={toolTipPlacement} actions={actions} />
            </div>
          )
        : null}
    </div>);
}
